import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { USER_PREFERENCES } from '..';
/**
 * Custom hook for managing user preferences.
 * Retrieves user preferences from the server and provides utility functions to access and manipulate them.
 * @returns An object containing the user preferences and a function to find a preference by key.
 */
export const usePreferences = (skip = false) => {
    const { data, loading } = useQuery(USER_PREFERENCES, {
        fetchPolicy: 'cache-first',
        skip,
    });
    const preferences = useMemo(() => (data?.userPreferences || []), [data]);
    /**
     * Finds a user preference by its key.
     * @param key - The key of the preference to find.
     * @returns The user preference with the specified key, or undefined if not found.
     */
    const find = (key) => preferences.find(preference => preference.key === key);
    return {
        preferences,
        find,
        loading,
    };
};
